import $ from 'jquery';
import ValidatedFormView from '../form/ValidatedFormView.js';
import '../form/FormControlHelp.mjs';

const ajaxError = 'Verbindung fehlgeschlagen. Bitte versuchen Sie es erneut.';
const voteFormSel = '#form-vote';
const FORM_PREFIX = 'tx_project_voting[voteFormData]';

export class VoteForm extends ValidatedFormView {
  constructor(options) {
    $(document).trigger('updateElementTrackingDataAttributes');

    super(Object.assign({
      formName: 'voteFormData',
      validations: {
        [`${FORM_PREFIX}[email]`]: ['required', 'email'],
        [`${FORM_PREFIX}[conditionsOfParticipation]`]: [{rule: 'checked', param: `${FORM_PREFIX}[conditionsOfParticipation]`}],
      },
    }, options));
  }

  doSubmit(event) {
    let $form = $(voteFormSel);

    _disableForm($form, event);

    $.ajax({
      type: 'POST',
      url: $form.data('ajaxUri'),
      data: $form.serialize(),
    }).done(function(response) {
      const $response = $(response);

      if ($response.data('success')) {
        const $voteFormModalBody = $('#modal-photo-contest-vote .modal-body');

        $voteFormModalBody.html($response.html());
      } else {
        // there are validation errors
        $form.replaceWith($response.find(voteFormSel));
        $form = $(voteFormSel); // Refresh selector, since the old form was replaced
        _reInitForm($form);
      }
    }).fail(function() {
      console.log(ajaxError);
      _reEnableForm($form);
    });
  }

  scrollToErrorMessage() {
    // Override to do nothing
    return false;
  }
}

function _reInitForm($form) {
  new VoteForm({
    $form,
  });
}

function _disableForm($form, event) {
  event.preventDefault();
  $form.find('button[name=\'submit\']').prop('disabled', true);
}

function _reEnableForm($form) {
  $form.off('submit');
  $form.find('button[name=\'submit\']').prop('disabled', false);
}
